import React from 'react'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import useTrans from '../../../../../hooks/useTrans'
import { useSelector } from 'react-redux'
import { getRequiredFields, getVisibleFields } from '../../../../../utils/servicegift'
import FormTextarea, { ENTER } from '../../../../atoms/FormTextarea/FormTextarea'

const NoteOrdine = ({ step, setStep, props }) => {
  const t = useTrans()
  const { service_gift } = useSelector((state) => state?.servicegift)
  const { utente } = useSelector((state) => state.utente)

  const visibleFields = getVisibleFields(
    service_gift,
    utente?.tipologia || props.values.utente.tipologia,
    'checkout'
  )
  const requiredFields = getRequiredFields(
    service_gift,
    utente?.tipologia || props.values.utente.tipologia,
    'checkout'
  )

  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets--full-row">
        {visibleFields.includes('checkout.note_ordine') && (
          <FormField
            label={
              t('Note ordine e istruzioni sulla consegna') +
              (requiredFields.includes('checkout.note_ordine') ? ' *' : ` (${t('opzionale')})`)
            }
            className="checkout__formfield"
          >
            <FormTextarea
              placeholder={t(
                "Inserisci le informazioni relative all'ordine e utili per la consegna"
              )}
              value={props.values.note_ordine}
              onChange={(e) => props.setFieldValue('note_ordine', e.target.value)}
              preventKeys={[ENTER]}
            />
          </FormField>
        )}
      </div>

      <Button
        label="Conferma dati"
        size="medium"
        variant="primary"
        disabled={props.errors.note_ordine}
        onClick={() => setStep(step + 1)}
        className="checkout__conferma-button"
      />
    </div>
  )
}

export default NoteOrdine
